import React, { useState, useRef, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import PatientData from './Data';
import PatientFilter from './Filter';
import PatientResult from './Result';
import ConsultationSuccessModal from './ModalList/AppointmentSuccess/consultationSuccess';
import VideoCallPatient from '../../components/AgoraVideoCall/videoCallPatient';
import QueueJoinModal from './QueueJoinModal';
import ProfConsultFilterReducer, {
  initialStateProf,
} from "../../context/profConsultFilterReducer";
import { CheckPermission } from "../../utils/CheckDesktopPermissions";
import { ProfConsultFilterState } from "../../context/profConsultFilterState";
import dialtone from "../../assets/notifications/dialtone.mp3";

const Patient = () => {
  const location = useLocation();
  const [hasPermission, setHasPermission] = useState(false);
  const [askPermission, setAskPermission] = useState(false);
  const [videoCall, setVideoCall] = useState(false);
  const [consultSuccess, setConsultSuccess] = useState(false);
  const [virtualGuardData, setVirtualGuardData] = useState([]);
  const [toastMessage, setToastMessage] = useState("");
  const [queue, setQueue] = useState(null);
  const [showQueueModal, setShowQueueModal] = useState(false);
  const [queueData, setQueueData] = useState(null);
  const [filterStompClient, setFilterStompClient] = useState(null);
  const audioElement = useRef(new Audio(dialtone));
  const [localTracks, setLocalTracks] = useState({
    audioTrack: null,
    videoTrack: null,
  });

  useEffect(() => {
    if (location.state?.showQueueModal && location.state?.queueData && location.state?.fromToken) {
      setShowQueueModal(true);
      setQueueData(location.state.queueData);
    }
  }, [location.state]);

  const stopRingCall = () => {
    audioElement.current.pause();

    audioElement.current.removeEventListener(
      "ended",
      () => {
        audioElement.current.pause();
      },
      false
    );
  };

  return (
    <ProfConsultFilterState
      initialState={initialStateProf}
      reducer={ProfConsultFilterReducer}
    >
      {!showQueueModal && <CheckPermission setHasPermission={setHasPermission} askPermission={askPermission} setAskPermission={setAskPermission}/>}
      {videoCall ? (
        <VideoCallPatient
          localTracks={localTracks}
          setLocalTracks={setLocalTracks}
          setQueue={setQueue}
          consultSuccess={consultSuccess}
          setConsultSuccess={setConsultSuccess}
          videoCallData={virtualGuardData}
          setVideoCall={setVideoCall}
          setMessage={setToastMessage}
        />
      ) : (
        <div className="patient">
          <div className="filter-result">
            <PatientFilter
              setShowQueueModal={setShowQueueModal}
              localTracks={localTracks}
              setConsultSuccess={setConsultSuccess}
              setVideoCallData={setVirtualGuardData}
              setVideoCall={setVideoCall}
              toastMessage={toastMessage}
              stopRingCall={stopRingCall}
              hasPermission={hasPermission}
              setAskPermission={setAskPermission}
              setFilterStompClient={setFilterStompClient}
              />
              
            <PatientResult
              stopRingCall={stopRingCall}
              audioElement={audioElement}
            />
          </div>
          {/* <div className="data">
            <PatientData />
          </div> */}
        </div>
      )}
      <ConsultationSuccessModal
        queue={queue}
        open={consultSuccess}
        setOpen={setConsultSuccess}
        handleClose={() => {
          setConsultSuccess(!consultSuccess);
        }}
        title="¡Felicidades, tu consulta ha finalizado con éxito!"
      />
      <QueueJoinModal
        open={showQueueModal}
        queueData={queueData}
        stompClient={filterStompClient}
        onAccept={(payload) => {
          setShowQueueModal(false);
          setVirtualGuardData(payload);
          setVideoCall(true);
        }}
        onDecline={() => {
          setShowQueueModal(false);
        }}
      />
    </ProfConsultFilterState>
  );
};

export default Patient;
